var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.05,
    height: 12.75,
    viewBox: "0 0 11.05 12.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,12.53a.75.75,0,0,0,1.06,0l4.78-4.77a.75.75,0,0,0,0-1.06.74.74,0,0,0-1.06,0L5.52,10.94,1.28,6.7a.74.74,0,0,0-1.06,0,.75.75,0,0,0,0,1.06ZM4.77,0V12h1.5V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortDown);
export default __webpack_public_path__ + "static/media/icon-sort-down.6036fbe9d97c467163de730c8f0a5162.svg";
export { ForwardRef as ReactComponent };